// VanJS Feather - Minimize
import van from "vanjs-core";
import { FeatherIcon, svgNamespace } from "../FeatherIcon.ts";
import { type SVGProps } from "../types.ts";

export const Minimize = (props: Partial<SVGProps> = {}) => {
  const { path } = van.tags(svgNamespace);

  return FeatherIcon(
    props,
    path({
      "d":
        "M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3",
    }),
  );
};
